export const blockIconsPhotoandimagePhotoCameraNew = (
	<span className='material-symbols-outlined'>photo_camera</span>
);
